// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"az_myc","headerTitle":"az_nyc","backButton":"az_oyc","backIcon":"az_pyc","closeIcon":"az_qyc"};